import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';
import { PagedResponse } from '@bioconnect-ui/shared-service'
import { Measure, MeasureServiceConfig, QuantityKind, Unit } from './measure-service.types';


@Injectable({
  providedIn: 'root',
})
export class MeasureService {
  constructor(
    private httpClient: HttpClient,
    @Inject('measureServiceConfig') private measureServiceConfig: MeasureServiceConfig
  ) {}

  private restServer = this.measureServiceConfig.restServer;

  /**
   * Retrieves a paged response of measures from the server based on the given page number
   * @param pageNumber The page number to retrieve
   * @returns An observable of the paged response
   */
  getMeasuresByPage(
    pageNumber: number, 
    page_size: number,
    sort_by = 'name',
    sort_direction = 'asc',
    filter = '' 
    ): Observable<PagedResponse> {
    return this.httpClient.get<PagedResponse>(
      `${this.restServer}/measures/measure/?page=${pageNumber}&page_size=${page_size}&sort=${sort_by}&direction=${sort_direction}&filter=${filter}`
    );
  }

  getMeasuresList(): Observable<Measure[]> {
    return this.httpClient.get<Measure[]>(
      `${this.restServer}/measures/measure/list/`
    ).pipe(map((result) => <Measure[]>result))
  }

  updateMeasures(measures: Measure[]): Observable<Measure[]> {
    if (measures.length) {
      return this.httpClient.post(
        `${this.restServer}/measures/measure/batch_update/`,
        measures
      ).pipe(map((result) => <Measure[]>result))
    } else {
      return of([]);
    }
  }

  deleteMeasures(measure_ids: number[]) {
    return this.httpClient.post(
      `${this.restServer}/measures/measure/batch_delete/`,
      { measure_ids: measure_ids }
    );
  }

  getQuantityKinds(): Observable<QuantityKind[]> {
    return this.httpClient.get<PagedResponse>(
      `${this.restServer}/ontology_service/quantity_kinds/`
    ).pipe(map((result) => <QuantityKind[]>result.results))
  }  

  getUnits(): Observable<Unit[]> {
    return this.httpClient.get<PagedResponse>(
      `${this.restServer}/ontology_service/units/?page_size=500`
    ).pipe(map((result) => <Unit[]>result.results));
  }

  getUnitsByQuantityKind(quantityKind: string): Observable<Unit[]> {
    return this.httpClient.get<Unit[]>(
      `${this.restServer}/ontology_service/units/units_by_quantity_kind/?name=${quantityKind}`
    );
  }
}
